export default "__VITE_PUBLIC_ASSET__49be38e6__"